<app-main-menu *ngIf="showNavBar"></app-main-menu>

    <router-outlet (activate)='onActivate($event)' (deactivate)='onDeactivate($event)'></router-outlet>
<global-search *ngIf="showNavBar"></global-search>

